import api from "../../api";
import { GET_AUTH_FAILURE, GET_AUTH_SUCCESS } from "../types";
import { signOut, isLogin, saveCookie, getCookie } from "../../utils/authService";

const state = {
  user: null,
  updatedAt: new Date(),
};

const actions = {
  authCheck({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (!data.email || !data.password) return reject();

      signOut();

      api.login(data).then(
        (response) => {
          if (!response.ok || !response.body) {
            commit(GET_AUTH_FAILURE);
            reject();
          }
          saveCookie("token", response.body.token);

          commit(GET_AUTH_SUCCESS, { user: response.body.user });
          resolve(response.body);
        },
        (response) => {
          commit(GET_AUTH_FAILURE);
          reject(response);
        }
      );
    });
  },

  authReset({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (!data.email) return reject();

      api.reset(data).then(
        (response) => {
          if (!response.ok || !response.body) {
            commit(GET_AUTH_FAILURE);
            reject();
          }
          commit(GET_AUTH_SUCCESS, { user: {} });
          resolve(response);
        },
        (response) => {
          commit(GET_AUTH_FAILURE);
          reject(response);
        }
      );
    });
  },
  isLogin({ commit }) {
    return new Promise((resolve, reject) => {
      if (isLogin()) {
        if (state.user) {
          return resolve();
        }
        return api.getMe().then(
          (response) => {
            if (!response.ok || !response.body) {
              commit(GET_AUTH_FAILURE);
              reject();
            }
            commit(GET_AUTH_SUCCESS, { user: response.body.user });
            resolve(response.body);
          },
          (response) => {
            signOut();
            commit(GET_AUTH_FAILURE);
            reject(response);
          }
        );
      }
      signOut();
      return reject();
    });
  },

  getSettings() {
    return new Promise((resolve, reject) => {
      api.startLoader();
      api.getSettings().then(
        (response) => {
          if (!response.ok) {
            api.stopLoader();
            return reject(response.body);
          }
          api.stopLoader();
          return resolve(response.body);
        },
        (response) => {
          api.stopLoader();
          return reject(response.body);
        }
      );
    });
  },

  updateSettings({ commit }, data) {
    return new Promise((resolve, reject) => {
      let avaliables = [
        "addCentavos",
        "auctionCentavos",
        "markCentavos",
        "reserveCentavos",
        "reserveHours",
        "commissionPercentualCentavos",
        "deadLineDays",
        "deadLineHours",
        "initialAuctionPercent",
        "isChatWhatsapp",
        "isBotWhatsapp",
        "isNotifyWhatsapp",
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

      api.updateSettings(obj).then(
        (response) => {
          if (!response.ok) {
            return reject(response);
          } else {
            return resolve();
          }
        },
        (response) => {
          return reject(response);
        }
      );
    });
  },

  Logout() {
    //commit(GET_AUTH_FAILURE);
    signOut();
  },

  exitWhatsApp({ commit }, query) {
    return new Promise((resolve, reject) => {
      api.startLoader();
      api.exitWhatsApp(query).then(
        (response) => {
          if (!response.ok) {
            api.stopLoader();
            return reject(response);
          }

          api.stopLoader();
          return resolve(response);
        },
        (response) => {
          api.stopLoader();
          return reject(response);
        }
      );
    });
  },
  forceWhatsApp({ commit }, query) {
    return new Promise((resolve, reject) => {
      api.startLoader();
      api.forceWhatsApp(query).then(
        (response) => {
          if (!response.ok) {
            api.stopLoader();
            return reject(response);
          }

          api.stopLoader();
          return resolve(response);
        },
        (response) => {
          api.stopLoader();
          return reject(response);
        }
      );
    });
  },

  refreshQRCode() {
    return new Promise((resolve, reject) => {
      api.startLoader();
      api.refreshQRCode().then(
        (response) => {
          if (!response.ok) {
            api.stopLoader();
            return reject(response);
          }
          api.stopLoader();
          return resolve(response);
        },
        (response) => {
          api.stopLoader();
          return reject(response);
        }
      );
    });
  },
};

const mutations = {
  [GET_AUTH_FAILURE](state) {
    state.user = null;
    state.updatedAt = new Date();
  },
  [GET_AUTH_SUCCESS](state, action) {
    state.user = JSON.parse(JSON.stringify(action.user));
    state.updatedAt = new Date();
  },
};

export default {
  state,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/store/modules/auth.js